import React from 'react'

interface AiAppCardProps {
  title: string;
  subtitle: string;
  ctaLabel?: string;
  onClick?: () => void;
}

export function AiAppCard({ title, subtitle, ctaLabel = 'Open app', onClick }: AiAppCardProps) {
  return (
    <div className="rounded-2xl border border-stone-200 bg-white/80 p-6 shadow-sm">
      <h2 className="text-lg font-semibold text-stone-900">{title}</h2>
      <p className="mt-1 text-sm text-stone-600">{subtitle}</p>
      <div className="mt-4">
        <button
          type="button"
          className="rounded-full bg-stone-900 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-stone-800"
          onClick={onClick}
        >
          {ctaLabel}
        </button>
      </div>
    </div>
  )
}
